import { makeFetchData } from "api/makeApiRequestType/makeFetchData";
import { validate, ValidationCallback } from "validation/validate";
import { FollowUpChecksParams } from "validation/getFieldChecker";

import { ApiRequestGetParamsRaw } from "api/makeApiRequest";

export interface Term {
	category: string;
	value: string;
	text: string;
}

type Output = { terms: Term[] };

const flagValidationErrorsInTerm: ValidationCallback<Term> = (
	input,
	{ flag, checkField }
) => {
	checkField("category", { type: "string" });
	checkField("value", { type: "string" });
	checkField("text", { type: "string" });
};

const flagValidationErrors: ValidationCallback<Output> = (
	input,
	{ checkField },
	auth
) => {
	checkField("terms", {
		type: "array",
		followUpChecks: arg => {
			const { findInvalid, value } = arg as FollowUpChecksParams<"array">;

			value.forEach((term, termOffset) => {
				const errorMessagePrefix = `Term ${termOffset}`;

				if (typeof term !== "object") {
					findInvalid(`${errorMessagePrefix}: not an object`);
					return;
				}

				validate(term, {
					doValidate: flagValidationErrorsInTerm,
					withErrors: errors => {
						findInvalid(`Row ${termOffset}: ${JSON.stringify(errors)}`);
					},
					auth
				});
			});
		}
	});
};

export const getMentorSearchTerms = makeFetchData<
	ApiRequestGetParamsRaw,
	Output
>("mentorSearchTerms", flagValidationErrors);
